import React from 'react';

import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Grid } from '@/components/shared/layout/grid';
import type { IParts } from '@/types/shared/parts';

interface PartsItemDetailProps {
  parts: IParts;
  size?: 'small' | undefined;
  dataTest?: string;
}

export const PartsItemDetail = ({
  parts,
  size,
  dataTest,
}: PartsItemDetailProps) => {
  const isSmall = size === 'small';
  return (
    <Grid rowGap="2">
      {!!parts?.title && (
        <Box>
          <Text
            as="h3"
            size={
              isSmall
                ? 'text-base'
                : { '@initial': 'text-base', '@sm': 'text-body-1' }
            }
            variant="text-red"
            font="bold"
            wrap
            dangerouslySetInnerHTML={{
              __html: parts?.title,
            }}
            data-test={dataTest + '_title'}
          />
        </Box>
      )}

      {!!(parts?.highlight || parts?.description) && (
        <Grid rowGap="1">
          {!!parts?.highlight && (
            <Box>
              <Text
                as="p"
                variant="text-red"
                size={
                  isSmall
                    ? 'text-base-2'
                    : {
                        '@initial': 'text-base-2',
                        '@sm': 'text-base',
                      }
                }
                wrap
                dangerouslySetInnerHTML={{
                  __html: parts?.highlight,
                }}
                data-test={dataTest + '_highlight'}
              />
            </Box>
          )}
          {!!parts?.description && (
            <Box>
              <Text
                as="p"
                size={
                  isSmall
                    ? 'text-base-2'
                    : {
                        '@initial': 'text-base-2',
                        '@sm': 'text-base',
                      }
                }
                wrap
                dangerouslySetInnerHTML={{
                  __html: parts?.description,
                }}
                data-test={dataTest + '_description'}
              />
            </Box>
          )}
        </Grid>
      )}

      {!!parts?.price && (
        <Box>
          <Text
            as="p"
            size={isSmall ? 'sm' : { '@initial': 'sm', '@sm': 'text-body-1' }}
            variant="text-red"
            font="bold"
            wrap
            dangerouslySetInnerHTML={{
              __html: parts?.price,
            }}
            data-test={dataTest + '_price'}
          />
        </Box>
      )}
    </Grid>
  );
};

PartsItemDetail.displayName = 'SectionPartsItemPartsItemDetail';
